import { render } from "./dialogDelete.vue?vue&type=template&id=5f82e8fc&scoped=true"
import script from "./dialogDelete.vue?vue&type=script&lang=js"
export * from "./dialogDelete.vue?vue&type=script&lang=js"

import "./dialogDelete.vue?vue&type=style&index=0&id=5f82e8fc&scoped=true&lang=css"

import exportComponent from "C:\\ClusterTrade\\NXM_CLUSTERTRADE\\nxm_clustertrade_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f82e8fc"]])

export default __exports__